import {
  createContext,
  useContext,
  useMemo,
  type PropsWithChildren,
  useState,
  type Dispatch,
  type SetStateAction,
} from 'react'

export type NewActivityContextProps = {
  /**
   * Available only when the ListItem.LeadingVisual is included with the newActivity prop set.
   * Used for setting the aria-label of the list item.
   */
  hasNewActivity: boolean
  setHasNewActivity: Dispatch<SetStateAction<boolean>>
}

const NewActivityContext = createContext<NewActivityContextProps | undefined>(undefined)

export const NewActivityProvider = ({children}: PropsWithChildren) => {
  const [hasNewActivity, setHasNewActivity] = useState(false)
  const contextProps = useMemo(
    () => ({hasNewActivity, setHasNewActivity}) satisfies NewActivityContextProps,
    [hasNewActivity],
  )

  return <NewActivityContext.Provider value={contextProps}>{children}</NewActivityContext.Provider>
}

export const useListItemNewActivity = () => {
  const context = useContext(NewActivityContext)
  if (!context) throw new Error('useListItemNewActivity must be used with NewActivityProvider.')
  return context
}

try{ NewActivityContext.displayName ||= 'NewActivityContext' } catch {}
try{ NewActivityProvider.displayName ||= 'NewActivityProvider' } catch {}